<div class="wccard mb-1 p-3 stickTopFilter">
  <div class="filter-container">
    <div class="d-flex">

    <div class="filter-icon">
      <i class="fa-regular fa-filters"></i> :
    </div>
    </div>
    <div class="filter-section">
        <div class="d-flex align-items-center  filter-width">
        <button data-testid="auto-app-webbtree-company-filters-button-1" class="btn-filters" [ngClass]="{'btn-filters-active': fortuneFilterClick == true}"  (click)="getFilterData('fortune500', '')">
          <span>
            <i class="fa-regular fa-building-memo "></i>
          </span>
         <div>Fortune 500</div>
        </button>

        <button data-testid="auto-app-webbtree-company-filters-button-2" class="btn-unicorn"  [ngClass]="{'btn-unicorn-active': unicornFilterClick == true}" (click)="getFilterData('unicorn', '')">
          <span>
            <i class="fa-solid fa-unicorn "></i>
          </span>
         <div>Unicorn</div>
        </button>
        <div class="dropdown">
          <button data-testid="auto-app-webbtree-company-filters-button-3" class="btn-filters" id="userDropdownButton"  (click)="getFilterData('industry', '')"
            appDropdownToggle aria-haspopup="true" aria-expanded="false" [ngClass]="{'btn-filters-active': industrySelectedChips?.length > 0}">
            <div>Industries <span class="mr-0" *ngIf="industrySelectedChips?.length">({{industrySelectedChips?.length}})</span></div>
            <span class="ml-1">
              <i class="fa-solid fa-chevron-down"></i>
            </span>

          </button>
          <app-multiselect-search class="dropdown-menu" [events]="parentSubject.asObservable()" [typeaheadLists]="industry_typeaheads" [filtertype]="'industry'" (searchInput)="getInputSearch($event)"
          aria-labelledby="userDropdownButton" [filterSelectList]="industrySelectedChips"></app-multiselect-search>
        </div>
        <div class="dropdown">
          <button data-testid="auto-app-webbtree-company-filters-button-4" class="btn-filters" id="userDropdownButton2" (click)="getFilterData('location', '')"
          appDropdownToggle aria-haspopup="true" aria-expanded="false" [ngClass]="{'btn-filters-active': locationSelectedChips?.length > 0}">
          <div>HQ Location <span class="mr-0" *ngIf="locationSelectedChips?.length">({{locationSelectedChips?.length}})</span></div>
          <span class="ml-1">
            <i class="fa-solid fa-chevron-down"></i>
          </span>
          </button>
          <app-multiselect-search class="dropdown-menu" [events]="parentSubject.asObservable()" [typeaheadLists]="location_typeaheads" [filtertype]="'location'" (searchInput)="getInputSearch($event)"
          aria-labelledby="userDropdownButton2" [filterSelectList]="locationSelectedChips"></app-multiselect-search>
        </div>

        <div class="dropdown">
            <button data-testid="auto-app-webbtree-company-filters-button-5" class="btn-filters" id="userDropdownButton3" (click)="getFilterData('companysize', '')"
          appDropdownToggle aria-haspopup="true" aria-expanded="false" [ngClass]="{'btn-filters-active': companySizesSelectedChips?.length > 0}">
              <div>Company Size<span class="mr-0" *ngIf="companySizesSelectedChips?.length">({{companySizesSelectedChips?.length}})</span></div>
              <span class="ml-1">
                <i class="fa-solid fa-chevron-down"></i>
              </span>
            </button>
            <app-multiselect-search class="dropdown-menu" [events]="parentSubject.asObservable()" [typeaheadLists]="companysizes_typeaheads" [filtertype]="'companysize'" (searchInput)="getInputSearch($event)"
        aria-labelledby="userDropdownButton3" [filterSelectList]="companySizesSelectedChips"></app-multiselect-search>
        </div>

        <span class="text-webbtree-green font-weight-600 pointer" (click)="clearAll()" *ngIf="industrySelectedChips?.length || locationSelectedChips?.length || companySizesSelectedChips?.length || fortuneFilterClick || unicornFilterClick">
          Clear All
        </span>

        <div style="width: 140px;font-weight: 500; display: flex; justify-content: end; margin-left: auto;" [ngClass]="{'ml-auto': router?.url.includes('company-compare')}">
        {{totalCompanies}} Result <span class="ml-3 text-9696" *ngIf="!router?.url.includes('company-compare')"> |</span>
      </div>
        </div>

        <div class="on-scroll-searchbox" [ngClass]="{'min-width-0': router?.url.includes('company-compare')}" >

      <div class="small-input" *ngIf="!router?.url.includes('company-compare') && showScrollDiv">
         <app-webbtree-company-search [elementStyles]="childStyles" (keywordSearchInput)="getCompanySearch($event)" [scrollSearch]="showScrollDiv" [searchvalue]="searchValue" ></app-webbtree-company-search>
         </div>
         </div>
    </div>
  </div>
</div>
